import React from 'react';

const LeadershipTeam = () => {
  const leadershipTeam = [
    {
      name: 'Mr. Ssewankambwe Nicholas',
      position: 'Founder & Chief Executive Officer',
      image: '/images/ceo.jpg',
      department: 'Programs',
    },
    {
      name: 'Prossy Nalubega',
      position: 'Human Resources Manager',
      image: '/images/hr.jpg',
      department: 'Programs',
    },
    {
      name: 'Joseph Wangi',
      position: 'Field Coordinator',
      image: '/images/advocacy.jpg',
      department: 'Operations',
    },
    {
      name: 'Faith Namukisa',
      position: 'SGBV Officer / Counsellor',
      image: '/images/counsellor.jpg',
      department: 'Support Services',
    },
    {
      name: 'Moses Matovu',
      position: 'Finance & Administration / Treasurer',
      image: '/images/finance.jpg',
      department: 'Support Services',
    },
  ];

  const deptStyle = {
    Programs:         { bg: 'rgba(37,99,235,0.1)',  color: '#1d4ed8' },
    Operations:       { bg: 'rgba(6,182,212,0.12)', color: '#0e7490' },
    'Support Services': { bg: 'rgba(245,158,11,0.1)', color: '#b45309' },
  };

  return (
    <div className="leadership-page">
      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet" />

      {/* Hero — padding-top equals navbar height so no spacer needed */}
      <section className="lead-hero">
        <div className="hero-bg-shapes">
          <div className="bg-shape s1" />
          <div className="bg-shape s2" />
          <div className="bg-shape s3" />
        </div>
        <div className="container hero-inner">
          <span className="hero-badge">Our People</span>
          <h1 className="hero-title">Executive Team</h1>
          <p className="hero-subtitle">
            The passionate professionals on the ground — driving programs, supporting
            communities, and turning RACOHI's mission into measurable impact every day.
          </p>
        </div>
        <div className="hero-wave">
          <svg viewBox="0 0 1440 80" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z" fill="#f8fafc"/>
          </svg>
        </div>
      </section>

      {/* Cards */}
      <section className="lead-section">
        <div className="container">
          <div className="row g-4 justify-content-center">
            {leadershipTeam.map((member, index) => {
              const dept = deptStyle[member.department] || { bg: 'rgba(0,0,0,0.06)', color: '#374151' };
              const initials = member.name.split(' ').map(n => n[0]).join('').slice(0, 2);
              return (
                <div key={index} className="col-lg-4 col-md-6">
                  <div className="lead-card" style={{ animationDelay: `${index * 0.08}s` }}>
                    <div className="lead-image-wrap">
                      <img
                        src={member.image}
                        alt={member.name}
                        className="lead-photo"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                      <div className="lead-initials-fallback">
                        <span>{initials}</span>
                      </div>
                      <div className="lead-image-overlay" />
                      <span
                        className="dept-badge"
                        style={{ background: dept.bg, color: dept.color }}
                      >
                        {member.department}
                      </span>
                    </div>
                    <div className="lead-body">
                      <h4 className="lead-name">{member.name}</h4>
                      <p className="lead-position">{member.position}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <style jsx>{`
        :root {
          --primary-blue: #2563eb;
          --secondary-blue: #1e40af;
          --accent-teal: #06b6d4;
          --accent-orange: #f59e0b;
          --text-gray: #6b7280;
          --light-gray: #f8fafc;
        }

        .leadership-page {
          min-height: 100vh;
          background: var(--light-gray);
        }

        /* ── Hero ──
           padding-top: 80px = fixed navbar height.
           No spacer div needed — the hero itself starts at page top
           and pushes its text content below the navbar. */
        .lead-hero {
          position: relative;
          padding: 80px 0 0;
          background: linear-gradient(135deg, #0e7490 0%, var(--accent-teal) 45%, var(--primary-blue) 100%);
          color: white;
          overflow: hidden;
        }

        .hero-inner {
          position: relative;
          z-index: 2;
          text-align: center;
          padding-top: 3.5rem;
          padding-bottom: 4.5rem;
        }

        .hero-bg-shapes { position: absolute; inset: 0; z-index: 1; pointer-events: none; }
        .bg-shape {
          position: absolute;
          border-radius: 50%;
          background: rgba(255,255,255,0.06);
        }
        .s1 { width: 340px; height: 340px; top: -100px; left: -60px; }
        .s2 { width: 200px; height: 200px; bottom: 10px; right: -40px; background: rgba(255,255,255,0.04); }
        .s3 { width: 120px; height: 120px; top: 50px; right: 30%; background: rgba(255,255,255,0.05); }

        .hero-badge {
          display: inline-block;
          background: rgba(255,255,255,0.15);
          color: white;
          padding: 0.4rem 1.2rem;
          border-radius: 50px;
          font-size: 0.8rem;
          font-weight: 600;
          letter-spacing: 1.2px;
          text-transform: uppercase;
          margin-bottom: 1.2rem;
          border: 1px solid rgba(255,255,255,0.25);
        }

        .hero-title {
          font-size: clamp(2.2rem, 5vw, 3.4rem);
          font-weight: 800;
          margin-bottom: 1rem;
          line-height: 1.1;
        }

        .hero-subtitle {
          font-size: 1.1rem;
          opacity: 0.85;
          max-width: 580px;
          margin: 0 auto;
          line-height: 1.65;
        }

        .hero-wave {
          position: relative; z-index: 2;
          line-height: 0; margin-bottom: -2px;
        }
        .hero-wave svg { width: 100%; height: 60px; display: block; }

        /* ── Cards ── */
        .lead-section { padding: 4rem 0 6rem; }

        .lead-card {
          background: white;
          border-radius: 1.4rem;
          overflow: hidden;
          box-shadow: 0 2px 16px rgba(0,0,0,0.07);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          height: 100%;
          position: relative;
          animation: fadeUp 0.55s ease-out both;
        }

        .lead-card::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 4px;
          background: linear-gradient(90deg, var(--accent-teal), var(--primary-blue));
          border-radius: 1.4rem 1.4rem 0 0;
          z-index: 1;
        }

        .lead-card:hover {
          transform: translateY(-7px);
          box-shadow: 0 18px 52px rgba(0,0,0,0.13);
        }

        .lead-image-wrap {
          position: relative;
          overflow: hidden;
          aspect-ratio: 3 / 4;
        }

        .lead-photo {
          width: 100%; height: 100%;
          object-fit: cover; object-position: center top;
          display: block; transition: transform 0.35s ease;
        }
        .lead-card:hover .lead-photo { transform: scale(1.05); }

        .lead-initials-fallback {
          display: none;
          width: 100%; height: 100%;
          background: linear-gradient(135deg, var(--accent-teal), var(--primary-blue));
          align-items: center; justify-content: center;
          font-size: 3.5rem; font-weight: 700; color: white; opacity: 0.9;
        }

        .lead-image-overlay {
          position: absolute; inset: 0;
          background: linear-gradient(to bottom, transparent 60%, rgba(0,0,0,0.08));
        }

        .dept-badge {
          position: absolute; top: 1rem; right: 1rem;
          padding: 0.35rem 0.85rem; border-radius: 50px;
          font-size: 0.75rem; font-weight: 700;
          letter-spacing: 0.3px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.12);
          backdrop-filter: blur(6px);
        }

        .lead-body { padding: 1.4rem; }

        .lead-name {
          font-size: 1.15rem; font-weight: 700;
          color: var(--secondary-blue); margin-bottom: 0.35rem;
        }

        .lead-position {
          color: var(--accent-orange); font-weight: 600;
          font-size: 0.88rem; margin: 0; line-height: 1.4;
        }

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(22px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        @media (max-width: 768px) {
          .lead-hero { padding-top: 70px; }
          .hero-inner { padding-top: 2.5rem; padding-bottom: 3.5rem; }
        }
      `}</style>
    </div>
  );
};

export default LeadershipTeam;
